import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-accommodation-helper',
  templateUrl: './accommodation-helper.component.html',
  styleUrls: ['./accommodation-helper.component.css']
})
export class AccommodationHelperComponent implements OnInit {
  cities: string[] = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla'];
  selectedCity: string;
  accommodationOptions: any = {
    'Madrid': [
      { id: 1, name: 'Apartment Rentals', description: 'Find apartments for rent in Madrid.' },
      { id: 2, name: 'Shared Rooms', description: 'Find shared rooms in Madrid.' }
    ],
    'Barcelona': [
      { id: 1, name: 'Apartment Rentals', description: 'Find apartments for rent in Barcelona.' },
      { id: 2, name: 'Shared Rooms', description: 'Find shared rooms in Barcelona.' }
    ],
    'Valencia': [
      { id: 1, name: 'Apartment Rentals', description: 'Find apartments for rent in Valencia.' },
      { id: 2, name: 'Shared Rooms', description: 'Find shared rooms in Valencia.' }
    ],
    'Sevilla': [
      { id: 1, name: 'Apartment Rentals', description: 'Find apartments for rent in Sevilla.' },
      { id: 2, name: 'Shared Rooms', description: 'Find shared rooms in Sevilla.' }
    ]
  };
  bestAreas: any = {
    'Madrid': ['Salamanca', 'Chamberí', 'Retiro'],
    'Barcelona': ['Eixample', 'Gràcia', 'Sarrià-Sant Gervasi'],
    'Valencia': ['Ciutat Vella', 'Eixample', 'Extramurs'],
    'Sevilla': ['Nervión', 'Los Remedios', 'Triana']
  };
  worstAreas: any = {
    'Madrid': ['Vallecas', 'Usera'],
    'Barcelona': ['Raval', 'Barceloneta'],
    'Valencia': ['Ruzafa', 'Benicalap'],
    'Sevilla': ['Macarena', 'Palmete']
  };
  appsWebsites: any[] = [
    { name: 'Idealista', link: 'https://www.idealista.com' },
    { name: 'Fotocasa', link: 'https://www.fotocasa.es' },
    { name: 'Pisocompartido', link: 'https://www.pisocompartido.com' },
    { name: 'Badi', link: 'https://www.badi.com' }
  ];
  adDetails: any = {
    name: '',
    email: '',
    city: '',
    description: ''
  };


  introSection = {
    cardId: 'A',
    imageUrl: this.guiFlow.getImage('78f147e0-6eb8-4bfa-9e7b-2565fc6f1200','userApp'),
    categories: [
      'Vivienda',
      'Estudiantes',
      'Alquiler'
    ],
    /* Photo by <a href="https://unsplash.com/@adrianvalverdem?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Adrián Valverde</a> on <a href="https://unsplash.com/photos/a-building-with-balconies-and-a-clock-on-the-side-of-it-aJ0y4RltkIY?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> */
    imageSize: 'md',
    title: 'Encontrar apartamento o habitación',
    longPar: '',
    longParLimit: '400',
    shortPara: 'En esta sección de nuestra plataforma, estamos aquí para facilitarte toda la información clave para que encuentres un piso lo antes posible.',
    description: 'Nuestra misión es simplificar tu experiencia y sabemos que la búsqueda de piso es uno de los mayores retos al llegar a España. A continuación te brindamos la guía y los consejos que necesitas. Queremos que tu transición a España como estudiante sea lo más sencilla posible. Estamos aquí para responder a tus preguntas y brindarte el apoyo necesario en cada paso del camino.',
    array: [
      {
        subtitle: 'Guía de búsqueda de vivienda',
        text: 'Te proporcionamos una guía detallada paso a paso para ayudarte a buscar y encontrar la vivienda ideal para ti.'
      },
      {
        subtitle: 'Preguntas importantes',
        text: 'Te ofrecemos una lista de preguntas clave que debes hacer al arrendador o a la agencia para asegurarte de tomar la mejor decisión.'
      },
      {
        subtitle: 'Información sobre áreas',
        text: 'Te brindamos conocimientos sobre diferentes áreas, sus características, niveles de seguridad y proximidad a servicios esenciales y transporte.'
      },
      {
        subtitle: 'Consejos de seguridad',
        text: 'Te ofrecemos consejos importantes para garantizar tu seguridad al buscar alojamiento y vivir en una nueva ciudad.'
      },
      {
        subtitle: 'Conexiones de transporte',
        text: 'Te proporcionamos información sobre las conexiones de transporte disponibles en cada área para facilitar tu movilidad.'
      },
      {
        subtitle: 'Enlaces útiles',
        text: 'Enlaces directos a recursos que te ayudarán a programar visitas, obtener citas y conocer los requisitos necesarios para alquilar una vivienda en España.'
      }
    ]
  };

  appsBuscar = {
    title: '¿Dónde buscar?',
    subtitle: '',
    array: [
      {
        title: '',
        subtitle: '',
        text: ''
      }
    ]
  }

  consejosBuscar = {
    title: 'Algunos consejos para la búsqueda de piso',
    array: [
      {
        title: 'Presionar para intentar programar una cita para visitar el piso.',
        text: ''
      },
      {
        title: 'Evitar las inmobiliarias'
      },
      {
        title: 'Crear un template de mensaje solicitando información y dando una pequeña introducción de quién eres.'
      },
      {
        title: 'Evitar Bajo (piso 0)'
      },
      {
        title: 'Programar las alertas de las herramientas de búsqueda'
      },
      {
        title: 'Prepara las preguntas a realizar antes de realizar las visitas'
      },
      {
        title: 'Es importante hacer un buen perfil, elegir buenas fotos y poner una descripción adecuada'
      },
      {
        title: 'Hay que intentar "venderse bien" así que no está demás mencionar que uno es ordenado y limpio etc.'
      }
    ]
  }
  
  card5 = {
    cardId: 'B',
    title: 'Hospedaje barato',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    imageSize: 'md',
    array: [
      {
        title: 'Hostelworld',
        description: '',
        imageUrl: this.guiFlow.getImage('3fc08762-4708-41b8-053a-cf0a1fb07f00','public'),
        link: 'www.hostelworld.com'
      },
      {
        title: 'Booking',
        description: '',
        imageUrl: this.guiFlow.getImage('4443ef96-8cf2-4c31-d7a7-7963a8410100','public'),
        link: 'www.booking.com'
      }
    ]
  };

  barriosMadrid = {
    title: 'Barrios Madrid',
    array: [
      {
        name: 'Centro',
        imageUrl: this.guiFlow.getImage('0ef13e31-36d2-4307-71f5-0a39de75a200','public')
        /* Photo by <a href="https://unsplash.com/@freeze_gb?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Giuseppe Buccola</a> on <a href="https://unsplash.com/photos/group-of-people-walking-beside-road-and-buildings-qBa0GnpEeuw?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> */
      },
      {
        name: 'Arganzuela',
        imageUrl: this.guiFlow.getImage('0363bb8d-3418-410d-faf3-b57d86dd7100','public')
      },
      {
        name: 'Retiro',
        imageUrl: this.guiFlow.getImage('8b92df3a-f553-4b52-d63a-41dd31828200','public'),
        // Photo by <a href="https://unsplash.com/@alevisionco?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Alev Takil</a> on <a href="https://unsplash.com/photos/brown-wooden-bridge-over-river-yD9rlSBT9Eo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
      },
      {
        name: 'Salamanca',
        imageUrl: this.guiFlow.getImage('8b92df3a-f553-4b52-d63a-41dd31828200','public'),
        // Photo by <a href="https://unsplash.com/@alevisionco?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Alev Takil</a> on <a href="https://unsplash.com/photos/brown-wooden-bridge-over-river-yD9rlSBT9Eo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
      }
  /*        
        name: 'Chamartin',
  name: 'Tetuán',
        name: 'Chamberi',
  name: 'Fuencarral-El Prado',
      'Moncloa-Aravaca',
      'Latina',
      'Carabanchel',
      'Usera',
      'Puente de Vallecas',
      'Moratalaz',
      'Ciudad Lineal',
      'Hortaleza',
      'Villa Verde',
      'Villa de Vallecas',
      'Vicálvaro',
      'San Blas Castillejas',
      'Barajas' */
      
    ]

  }
/* 
  Barrio de Salamanca: Conocido por sus elegantes calles, boutiques de lujo y hermosos edificios. Es una de las zonas residenciales más codiciadas.

Chamberí: Ofrece un ambiente tradicional combinado con modernidad, lleno de encantadoras plazas y calles.

Jerónimos: Cerca del Parque del Retiro, esta zona es famosa por sus impresionantes propiedades y su proximidad a algunos de los mejores museos de Madrid.

Chamartín: Incluye áreas como El Viso y Castellana, conocidas por sus lujosas casas y apartamentos espaciosos.

Centro (Barrios como Justicia y Malasaña): Aunque pueden ser más asequibles que las anteriores, estas áreas centrales tienen mucha demanda debido a su vibrante vida nocturna y cultural.
 */


  barriosBarcelona = {
    title: 'Barrios Barcelona',
    array: [
    {
      name: 'Barcelona',
      imageUrl: this.guiFlow.getImage('0363bb8d-3418-410d-faf3-b57d86dd7100','public')
    },
    {
      name: 'Sants',
      imageUrl: this.guiFlow.getImage('0363bb8d-3418-410d-faf3-b57d86dd7100','public')
    },
    {
      name: 'Eixample',
      imageUrl: this.guiFlow.getImage('8b92df3a-f553-4b52-d63a-41dd31828200','public'),
      // Photo by <a href="https://unsplash.com/@alevisionco?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Alev Takil</a> on <a href="https://unsplash.com/photos/brown-wooden-bridge-over-river-yD9rlSBT9Eo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
    },
    {
      name: 'Born',
      imageUrl: this.guiFlow.getImage('408c1773-53e6-4595-41ec-0f5d83104600','public'),
      // Photo by <a href="https://unsplash.com/@arpablo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Armin Pfarr</a> on <a href="https://unsplash.com/photos/a-group-of-people-sitting-at-tables-under-umbrellas-Rfdi9Hvwufg?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  
    },
    {
      name: 'Gracia',
      imageUrl: this.guiFlow.getImage('8b92df3a-f553-4b52-d63a-41dd31828200','public'),
      // Photo by <a href="https://unsplash.com/@alevisionco?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Alev Takil</a> on <a href="https://unsplash.com/photos/brown-wooden-bridge-over-river-yD9rlSBT9Eo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
    }
/*    'Les Corts',
    'A evitar:',
    'Gotico',
    'Raval',
    'Barceloneta',
    'Besos/Maresme',
    'La Mina',
    'Mejores Zonas en Barcelona:',
    'Eixample',
    'La font de la Guatlla',
    'Sant Antoni',
    'Sant Andreu',
    'Clot',
    'Sants' */
  ]
}

  barriosPeligrososMadrid = [
    'Puente de Vallecas',
    'Lavapiés',
    'Ciudad Lineal',
    'Carabanchel',
    'Usera',
    'Tetuán',
    'Chamberí',
    'Villa de Vallecas'
  ];

  barriosCarosMadrid = [
    'Recoletos,Salamanca',
    'Castellana,Salamanca',
    'Chueca-Justicia,Centro',
    'Almagro,Chamberí',
    'Jerónimos,Retiro',
    'Trafalgar,Chamberí',
    'Malasaña-Universidad,Centro',
    'El Viso,Chamartín',
    'Goya,SalamancaGoya,Salamanca',
    'Huertas-Cortes,Centro'
]

barriosCarosBarna = [
  'Eixample',
  'Sarrià-Sant Gervasi',
  'Les Corts',
  'Pedralbes',
  'Ciutat Vella (incluyendo El Gòtic y El Born)'
];

barriosPeligrososBarna = [
  'El Raval',
  'La Mina',
  'Ciutat Meridiana',
  'Besòs y Maresme',
  'Torre Baró'
];

  @ViewChild('guia') guia: ElementRef<HTMLDivElement>;
  @ViewChild('tarifas') tarifas: ElementRef<HTMLDivElement>;
  @ViewChild('buscar') buscar: ElementRef<HTMLDivElement>;
  @ViewChild('zonas') zonas: ElementRef<HTMLDivElement>;

  sections = [
    { id: 'guia', title: 'Guía de hospedaje en PDF', content: 'Content for Section 1...' },
    { id: 'tarifas', title: 'Precios orientativos', content: 'Content for Section 1...' },
    { id: 'buscar', title: '¿Dónde buscar?', content: 'Content for Section 2...' },
    { id: 'zonas', title: 'Zonas recomendadas y a evitar', content: 'Content for Section 3...' }
  ];

  constructor(private guiFlow: GuiFlowService,private router: Router) { }

  ngOnInit(): void { }

  selectCity(city: string) {
    this.selectedCity = city;
  }

  postAd() {
    // Implement logic to post ad
    console.log('Ad posted:', this.adDetails);
  }

  openPdf(){
    this.router.navigateByUrl('pdf-view/'+'guiaMadridHospedaje');
  }

  openLink(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02','_blank');
  }

  scrollIntoView(selection): void {
    switch(selection){
      case 'guia':
        this.guia.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'tarifas':
        this.tarifas.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'buscar':
          this.buscar.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
      case 'zonas':
        this.zonas.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
    }
  }
}
